import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function BottomNavigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useAuth();

  const isOnboarding = currentUser && !(currentUser.familyIds?.length > 0);
  if (isOnboarding) return null;

  // Pre-app / auth & entry routes: the in-app tab bar doesn't belong here, even
  // if a signed-in user lands on one (e.g. an admin opening an invite link).
  const AUTH_ROUTES = [
    '/auth',
    '/accept-invitation',
    '/create-invited-account',
    '/onboard',
    '/awaiting-approval',
    '/gift',
    '/redeem-gift',
  ];
  if (AUTH_ROUTES.some(route => location.pathname.startsWith(route))) return null;

  const navItems = [
    {
      id: 'record',
      path: '/record',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
        </svg>
      ),
      label: 'Record'
    },
    {
      id: 'listen',
      path: '/listen',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10" strokeWidth={1.5} stroke="currentColor" fill="none" />
          <polygon points="10,8 16,12 10,16" fill="currentColor" />
        </svg>
      ),
      label: 'Listen'
    },
    {
      id: 'family',
      path: '/family',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
      label: 'Family'
    },
    {
      id: 'dashboard',
      path: '/dashboard',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <rect x="3" y="3" width="7" height="7" rx="1" strokeWidth={2} />
          <rect x="14" y="3" width="7" height="7" rx="1" strokeWidth={2} />
          <rect x="3" y="14" width="7" height="7" rx="1" strokeWidth={2} />
          <rect x="14" y="14" width="7" height="7" rx="1" strokeWidth={2} />
        </svg>
      ),
      label: 'Dashboard'
    },
    {
      id: 'profile',
      path: '/profile',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      ),
      label: 'Profile'
    }
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-white dark:bg-[#0d1520] border-t border-gray-200 dark:border-white/10 z-[9999]">
      <div className="flex justify-around items-start h-20 px-2 pt-1 pb-8">
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => navigate(item.path)}
            className={`flex flex-col items-center justify-start flex-1 py-2 px-1 transition-colors ${
              isActive(item.path)
                ? 'text-cerulean'
                : 'text-gray-500 dark:text-white/40 hover:text-gray-700 dark:hover:text-white/70'
            }`}
          >
            <div className={`mb-1 ${isActive(item.path) ? 'scale-110' : ''} transition-transform`}>
              {item.icon}
            </div>
            <span className="text-xs font-medium">{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}

export default BottomNavigation;
